import React from 'react';
import {
  Switch,
  Route,
} from 'react-router-dom';
import Background from '../../components/Background';
import Header from '../../components/Header';
import ContainerContent from '../../components/ContainerContent';
import ContainerWithLogo from '../../components/ContainerWithLogo';
import PageTitle from '../../components/PageTitle';
import ErrorMessage from '../../components/ErrorMessage';
import {pathnames as P} from '../../constants/pathnames';
import ErrorBoundary from '../../components/ErrorBoundary';

const steps = require.context('../../pages', true, /^\.\/Step.*\/(index.js)$/);

const getId = item => {
  const {groups: {id}} = item.match(/.\/Step(?<id>\d*)\/.*/);
  return id
};

const exports = steps.keys().reduce((acc, key) => {
  const id = getId(key);
  acc[id] = steps(key).default;
  return acc;
}, {});

const routes = steps.keys().map(step => {
  const id = getId(step);
  return {
    path: P.GET_STEP_PATH(id),
    component: exports[id]
  }
});

const Step = () => (
  <ErrorBoundary>
    <ErrorMessage/>
    <Header/>
    <Background>
      <PageTitle/>
      <ContainerContent>
        <ContainerWithLogo>
          <Switch>
            {routes.map((route, ind) => {
              return (
                <Route
                  key={ind}
                  path={route.path}
                  render={props => (
                    <route.component {...props} routes={route}/>
                  )}
                />
              )
            })}
          </Switch>
        </ContainerWithLogo>
      </ContainerContent>
    </Background>
  </ErrorBoundary>
);

export default Step;
